// ── Geo → SVG coordinate conversion ─────────────────────────────────────────
// The embedded world SVG outline is closer to a Mercator world map than a
// strict equirectangular projection. Using Mercator aligns markers to landmasses.

export const GEO = { minLon: -180, maxLon: 180 } as const
export const VB_W = 901.49
export const VB_H = 665.96301

// SVG viewBox with padding so the full map stays visible in the viewport.
export const VIEW_MIN_X = -60
export const VIEW_MIN_Y = -60
export const VIEW_W = 1021.49
export const VIEW_H = 785.96301
export const VIEW_BOX = `${VIEW_MIN_X} ${VIEW_MIN_Y} ${VIEW_W} ${VIEW_H}`
/** Bottom strip reserved for the UTC axis overlay (viewBox units). */
export const TZ_AXIS_STRIP = 44

export function toSVG(lat: number, lon: number) {
  // Wrap longitude to [-180, 180] so points near the dateline don't jump.
  let L = lon
  while (L > 180) L -= 360
  while (L < -180) L += 360
  // Clamp to Mercator-safe range
  const phi = Math.max(-85, Math.min(85, lat))
  const x = ((L - GEO.minLon) / (GEO.maxLon - GEO.minLon)) * VB_W
  const rad = (phi * Math.PI) / 180
  const mercN = Math.log(Math.tan(Math.PI / 4 + rad / 2))
  const maxMerc = Math.log(Math.tan(Math.PI / 4 + (85 * Math.PI) / 360))
  const y01 = 0.5 - mercN / (2 * maxMerc)
  return { x, y: y01 * VB_H }
}
